import { Dispatch } from 'redux';
import { createSlice } from "@reduxjs/toolkit";
import { getAvailableLiquidityApi } from '../../_apis/LiquidityCrud';

export interface LIQUIDITY_INITIAL_STATE {
  error: boolean;
  isLoading: boolean;
  liquidity: string;
}

const initialState: LIQUIDITY_INITIAL_STATE = {
  error: false,
  isLoading: false,
  liquidity: '',
};

const slice = createSlice({
  name: "liquidity",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getLiquidityPayload(state, action) {
      state.isLoading = false;
      state.liquidity = action.payload.liquidity;
    },
  },
});

export default slice.reducer;

export const getAvailableLiquidity = (sourceCabnId: string, sourceNetworkId: string, token: string | null) => (dispatch: Dispatch) => {
  dispatch(slice.actions.startLoading());
  getAvailableLiquidityApi(sourceCabnId, sourceNetworkId, token)
    .then((res) => {
        let { liquidity } = res.data.body
      dispatch(slice.actions.getLiquidityPayload({ liquidity }));
    })
    .catch((e) => {
      if (e.response) {
        dispatch(slice.actions.hasError(e.response?.data?.status?.message));
      } else {
        dispatch(slice.actions.hasError("Something went wrong. Try again later!"));
      }
    });
};

